export default [
  {
    path: '/armacoes',
    name: 'Armacoes',
    component: () => import(/* webpackChunkName: "Armacoes" */ '../armacoes/Armacoes')
  },
  {
    path: '/armacoes-cadastro',
    name: 'ArmacoesCadastro',
    component: () => import(/* webpackChunkName: "ArmacoesCadastro" */ '../armacoes/ArmacoesCadastro')
  },
  {
    path: '/armacoes-lista',
    name: 'ArmacoesLista',
    component: () => import(/* webpackChunkName: "ArmacoesLista" */ '../armacoes/ArmacoesLista')
  }
]



// WEBPACK FOOTER //
// ./src/pages/configuracoes/armacoes/router.js